export const EMPLOYEE_ROLE = {
  Owner: 1,
  Manager: 2,
  Cashier: 3,
  Employee: 4
};
